import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {IncubatorCreateLineController} from 'app/controllers/IncubatorCreateLineController';
import {inject, observer} from 'mobx-react';
import {ParamsInterface} from 'app/utils/Get';
import {BLUE} from 'app/lines/line_helpers';
import {isClosedLine} from 'utils/line_helpers';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface Props {
    controller?: IncubatorCreateLineController
}

const MIN_BET_AMOUNT = 1;

@inject('controller')
@observer
export default class IncubatorOpenLineOrAddTime extends Component<Props> {
    get controller(): IncubatorCreateLineController {
        return this.props.controller;
    }

    state = {
        closeButtonDisabled: false,
        plus2ButtonDisabled: false,
        plus5ButtonDisabled: false
    };

    handleKeyPress = (e: KeyboardEvent): void => {
        if (e.metaKey || e.ctrlKey || document.activeElement.className === 'chat__input-text js-chat-input') {
            return;
        }
        this.handleInputs(e.key);
        this.handleFocus(e.key);
    };

    handleInputs(value: string): void {
        if (value === 'T' || value === 't') {
            this.disableButton(
                () => this.addTime({time: 2}),
                'plus2ButtonDisabled'
            );
        }
        if (value === 'F' || value === 'f') {
            this.disableButton(
                () => this.addTime({time: 5}),
                'plus5ButtonDisabled'
            );
        }
        if (value === 'C' || value === 'c') {
            this.disableButton(
                () => this.controller.close({id: this.controller.incubatorGame.id}),
                'closeButtonDisabled'
            );
        }
        if (value === 'A' || value === 'a') {
            this.disableButton(
                () => this.controller.acceptAndClose({id: this.controller.incubatorGame.id}),
                'closeButtonDisabled'
            );
        }
    }

    handleFocus(value:string): void {
        if (value === 'ArrowRight') {
            const rightInput = document.getElementById('line[coef_2]');

            if (rightInput) {
                rightInput.focus();
            }
        }
        if (value === 'ArrowLeft') {
            const leftInput = document.getElementById('line[coef_1]');

            if (leftInput) {
                leftInput.focus();
            }
        }
    }

    componentDidMount(): void {
        document.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.handleKeyPress);
    }

    handleAddTime5 = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();

        this.disableButton(
            () => this.addTime({time: 5}),
            'plus5ButtonDisabled'
        );
    };

    handleAddTime2 = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();

        this.disableButton(
            () => this.addTime({time: 2}),
            'plus2ButtonDisabled'
        );
    };

    addTime = (params: ParamsInterface): Promise<Response> => this
        .controller.addTime({...params, id: this.controller.incubatorGame.id});

    hasLoss(): boolean {
        const {coef1_win, coef2_win, coef_1, coef_2} = this.controller.incubatorGame.lineStore.collection;
        return this.coefProfit(coef1_win, coef_1) < 0 ||
            this.coefProfit(coef2_win, coef_2) < 0;
    }

    coefProfit(coef_win: string, coef: string): number {
        const {pledge} = this.controller.incubatorGame.lineStore.collection;
        return Number(pledge) + Number(coef_win) - (MIN_BET_AMOUNT * Number(coef) - MIN_BET_AMOUNT);
    }

    disableButton = (fun: () => Promise<unknown>, state: string): void => {
        if (this.state[state]) {
            return;
        }
        this.setState({[state]: true});
        fun().finally(() => {
            this.setState({[state]: false});
        });
    };

    render(): ReactNode {
        const {color, status} = this.controller.incubatorGame.lineStore.collection;
        const lineClosed = color !== BLUE;
        const disablePlusButtons = this.hasLoss() || isClosedLine(status) ? ' button-adaptive_disable' : '';
        const {plus2ButtonDisabled, plus5ButtonDisabled} = this.state;

        return lineClosed
            ? <button
                onClick={this.handleAddTime2}
                type="button"
                className={`button-adaptive button-adaptive_full-thin icon ${!lineClosed}`}
                disabled={!lineClosed || this.hasLoss()}>
                {I18n.t('incubator_open_line')}
            </button>
            : <>
                <button
                    onClick={this.handleAddTime2}
                    type="button"
                    className={`button-adaptive button-adaptive_full-thin icon ${disablePlusButtons}`}
                    disabled={plus2ButtonDisabled || this.hasLoss()}
                >
                    <span className="icon">
                        <SpriteIcon name="#svg-icon-plus-b" className="svg-default"/>
                    </span>
                    <span className="name">2m</span>
                </button>
                <button
                    onClick={this.handleAddTime5}
                    type="button"
                    className={`button-adaptive button-adaptive_full-thin icon ${disablePlusButtons}`}
                    disabled={plus5ButtonDisabled || this.hasLoss()}
                >
                    <span className="icon">
                        <SpriteIcon name="#svg-icon-plus-b" className="svg-default"/>
                    </span>
                    <span className="name">5m</span>
                </button>
            </>;
    }
}
